(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
$(document).ready(function () {
  if ($(window).width() <= 767) {
    var $parent = $('.footer-custom-css');
    var $third = $parent.find('.t4s-custom-col').eq(2);
    var $fourth = $parent.find('.t4s-custom-col').eq(3);

    if ($third.length && $fourth.length) {
      $third.before($fourth);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.mySwiper', {
    loop: true,
    spaceBetween: 20,
    slidesPerView: 4,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      320: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    },
    on: {
      slideChange: function () {
        markLastVisibleSlide(this);
      },
      init: function () {
        markLastVisibleSlide(this);
      }
    }
  });

  function markLastVisibleSlide(swiperInstance) {
    const allSlides = swiperInstance.slides;
    allSlides.forEach(slide => slide.classList.remove('last-visible'));

    const lastVisibleIndex = swiperInstance.activeIndex + swiperInstance.params.slidesPerView - 1;
    if (allSlides[lastVisibleIndex]) {
      allSlides[lastVisibleIndex].classList.add('last-visible');
    }
  }
});


  } catch(e) { console.error(e); }
})();
})();
